// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar-container {
  display: flex;
  justify-content: space-between;
}
.avatar-container .avatar-image {
  background-color: #282881;
  border-radius: 50%;
  width: 55px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  color: #bf9e1d;
  font-weight: bold;
  font-size: larger;
}
.avatar-container .avatar-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
}
.avatar-container .avatar-body .avatar-name {
  font-weight: 550;
  font-size: large;
}
.avatar-container .avatar-body .avatar-message span {
  margin-right: 5px;
  color: #282881;
}
.avatar-container .date-message {
  position: absolute;
  top: 2px;
  right: 5px;
  font-size: 13px;
  color: #d3d3d3;
}`, "",{"version":3,"sources":["webpack://./src/components/Chat/Avatar/avatar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;AACF;AACE;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAAJ;AAEI;EACE,gBAAA;EACA,gBAAA;AAAN;AAKM;EACE,iBAAA;EACA,cAAA;AAHR;AAQE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AANJ","sourcesContent":[".avatar-container {\n  display: flex;\n  justify-content: space-between;\n\n  .avatar-image {\n    background-color: #282881;\n    border-radius: 50%;\n    width: 55px;\n    height: 55px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 15px;\n    color: #bf9e1d;\n    font-weight: bold;\n    font-size: larger;\n  }\n\n  .avatar-body {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex-grow: 1;\n\n    .avatar-name {\n      font-weight: 550; \n      font-size: large;\n    }\n  \n    .avatar-message {\n\n      span{\n        margin-right: 5px;\n        color: #282881;\n      }\n    }\n  }\n\n  .date-message {\n    position: absolute;\n    top: 2px;\n    right: 5px;\n    font-size: 13px;\n    color: #d3d3d3;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
